// Generated types for Expression
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ExpressionType } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ExpressionReadAPI extends RFLPElementReadAPI {
  /** The formal expression text, e.g. 'mass < 5 kg' or 'latency_ms <= 20'. */
  expression: string;
  /** TEXT in v1; NUMERIC/LOGICAL reserved for phase-2 parser. */
  expression_type?: ExpressionType;
  /** Timestamp of the last evaluation pass. None until first evaluated. */
  last_evaluated_at?: string | null;
  /** Universal staleness flag — true when this expression needs (re-)evaluation. New expressions land in stale=True; the orchestrator clears it on successful eval. The dirty walk sets it back to True when an input changes. Subclasses MAY also expose a richer verdict field (e.g. `Constraint.status`); `is_stale` is the shared staleness flag the orchestrator filters on. */
  is_stale?: boolean;
  /** Last evaluation error, or None if the expression evaluated successfully. Cleared on successful eval. */
  evaluation_error?: string | null;
}

export interface ExpressionWriteAPI extends RFLPElementWriteAPI {
  /** The formal expression text, e.g. 'mass < 5 kg' or 'latency_ms <= 20'. */
  expression: string;
  /** TEXT in v1; NUMERIC/LOGICAL reserved for phase-2 parser. */
  expression_type?: ExpressionType;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ExpressionReadAPISchemaObject = RFLPElementReadAPISchemaObject.extend({
  expression: z.string(),
  expression_type: z.nativeEnum(ExpressionType).optional(),
  last_evaluated_at: z.string().nullable().optional(),
  is_stale: z.boolean().optional(),
  evaluation_error: z.string().nullable().optional(),
}).passthrough();
export const ExpressionReadAPISchema: z.ZodType<ExpressionReadAPI> = ExpressionReadAPISchemaObject;

export const ExpressionWriteAPISchemaObject = RFLPElementWriteAPISchemaObject.extend({
  expression: z.string(),
  expression_type: z.nativeEnum(ExpressionType).optional(),
}).passthrough();
export const ExpressionWriteAPISchema: z.ZodType<ExpressionWriteAPI> = ExpressionWriteAPISchemaObject;
